import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ 
  children, 
  allowedProfiles = [], 
  redirectTo = '/ponto',
  showAccessDenied = false 
}) => {
  const { user } = useAuth();

  // Se não está logado, redireciona para login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Se não especificou perfis permitidos, permite todos
  if (allowedProfiles.length === 0) {
    return children;
  }

  // Verifica se o perfil do usuário está na lista de permitidos
  const hasAccess = allowedProfiles.includes(user.perfil);

  if (!hasAccess) {
    if (showAccessDenied) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Acesso Negado
            </h3>
            <p className="text-sm text-gray-500 mb-4">
              Você não tem permissão para acessar esta área.
            </p>
            <p className="text-xs text-gray-400">
              Perfil atual: <span className="font-medium">{user.perfil}</span>
            </p>
            <div className="mt-4">
              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
              >
                Voltar
              </button>
            </div>
          </div>
        </div>
      );
    }
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;

